import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiArrowRight, FiPhone, FiMail, FiMessageCircle } = FiIcons;

const ClosingSection = () => {
  return (
    <section className="py-16 relative bg-gradient-to-br from-gray-900 to-black">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="backdrop-blur-xl bg-black/60 rounded-3xl p-8 sm:p-12 border border-purple-500/30 shadow-2xl text-center"
        >
          <motion.h2
            className="text-3xl sm:text-4xl font-bold text-white mb-6"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            viewport={{ once: true }}
          >
            Travel,
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-orange-400 via-pink-400 to-yellow-400">
              Elevated
            </span>
            —Let's Make Your Next Escape Unforgettable
          </motion.h2>

          <motion.p
            className="text-xl text-gray-200 mb-10 max-w-4xl mx-auto leading-relaxed"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.4 }}
            viewport={{ once: true }}
          >
            Life's too short for ordinary vacations. Discover a world of luxury,
            convenience, and personal attention—start your journey with
            SeetaLuxuryEscape today.
          </motion.p>

          <motion.div
            className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-10"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.6 }}
            viewport={{ once: true }}
          >
            <motion.a
              href="https://seetaluxuryescape.pathfndr.io/search/trips#travel"
              target="_blank"
              rel="noopener noreferrer"
              whileHover={{
                scale: 1.05,
                boxShadow: "0 20px 40px rgba(251,146,60,0.4)",
              }}
              whileTap={{ scale: 0.95 }}
              className="bg-gradient-to-r from-orange-500 to-pink-500 text-white px-8 py-4 rounded-full font-semibold text-lg shadow-xl hover:shadow-2xl transition-all duration-300 flex items-center gap-3"
            >
              Get My Free Custom Itinerary
              <SafeIcon icon={FiArrowRight} className="text-xl" />
            </motion.a>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.8 }}
            viewport={{ once: true }}
            className="space-y-4"
          >
            <p className="text-orange-200 text-lg font-medium">
              Questions? We're here to help!
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center items-center text-gray-300">
              <div className="flex items-center gap-2 hover:text-orange-400 transition-colors">
                <SafeIcon icon={FiPhone} className="text-lg" />
                <span>Call us at (416) 555-0123</span>
              </div>
              <div className="flex items-center gap-2 hover:text-orange-400 transition-colors">
                <SafeIcon icon={FiMessageCircle} className="text-lg" />
                <span>Chat live now</span>
              </div>
              <div className="flex items-center gap-2 hover:text-orange-400 transition-colors">
                <SafeIcon icon={FiMail} className="text-lg" />
                <span>hello@seetaluxuryescape.com</span>
              </div>
            </div>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default ClosingSection;